/* eslint-disable react/prop-types */
import React from "react";
import { Info } from "lucide-react";
import { cn } from "../../lib/utils";

export const InfoBar = ({ message, className, iconClassName, textClassName, ...props }) => {
  return (
    <div
      className={cn(
        "flex items-start gap-2 p-3 bg-blue-50 border border-blue-200 rounded-md",
        className
      )}
      {...props}
    >
      <Info
        className={cn(
          "h-4 w-4 text-blue-600 flex-shrink-0 mt-0.5",
          iconClassName
        )}
      />
      <span
        className={cn(
          "text-sm text-blue-800",
          textClassName
        )}
      >
        {message}
      </span>
    </div>
  );
};
